<template>
  <div
    class="p-3"
    @click="onClickLoginUserTab">
    <div class="d-flex justify-content-between">
      <div
        class="d-flex align-items-center">
        <img
          v-if="user.avatar"
          :src="user.avatar"
          class="img-fluid side-members__img mr-3 rounded-circle">
        <b-avatar
          v-else
          size="60px"
          class="mr-3"
          :text="user.name|initial" />
        <div class="side-members__info">
          <p class="side-members__name">
            {{ user.name }}
          </p>
          <p class="side-members__team">
            {{ user.position }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState('auth', ['user'])
  },
  methods: {
    onClickLoginUserTab(){
      this.$emit('click')
    }
  }
}
</script>

<style lang="scss" scoped>
.side-members{
  &__img{
    object-fit: cover; 
    width: 60px;
    height: 60px;
    max-width: 60px;
  }

  &__name{
    font-weight: bold;
    font-size: $fs-lg;
  }

  &__team{
    font-size: $fs-s;
    line-height: 150%;
    font-weight: bold;
  }
}
</style>